const USER_TYPE = {
  unknown: 0,
  beginner: 1,
  intermediate: 2,
  advanced: 3,
  super: 4
}

const ADMIN_TYPE = {
  on: 1,
  off: 0
}

export { USER_TYPE, ADMIN_TYPE }
